// Seiteneinteilung für Tabellen (Schritt 3: Query-Fan-outs und zitierte Quellen).

export const PAGE_SIZE = 10;

export function pageCount(total: number, size = PAGE_SIZE): number {
  return Math.max(1, Math.ceil(total / size));
}

/** Seitenzahl auf den gültigen Bereich bringen (z. B. nach einem Filter, der die Liste kürzt). */
export function clampPage(page: number, total: number, size = PAGE_SIZE): number {
  return Math.min(Math.max(1, Math.floor(page) || 1), pageCount(total, size));
}

export type Pagination<T> = {
  page: number;
  pages: number;
  items: T[];
  /** 1-basiert, für „11–20 von 152“. Bei leerer Liste 0. */
  from: number;
  to: number;
  total: number;
};

export function paginate<T>(items: readonly T[], page: number, size = PAGE_SIZE): Pagination<T> {
  const total = items.length;
  const current = clampPage(page, total, size);
  const start = (current - 1) * size;
  const slice = items.slice(start, start + size);
  return {
    page: current,
    pages: pageCount(total, size),
    items: slice,
    from: total === 0 ? 0 : start + 1,
    to: start + slice.length,
    total,
  };
}
